import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import FormControl from '../FormControl/FormControl.js';
import { isText } from '../Util/validations.js';

const Text = (_param)=> {
    var { validations =[
        isText
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "validations"
    ]);
    return React.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
        validations: validations
    }, rest));
};
var Text$1 = Text;

export { Text$1 as default };
//# sourceMappingURL=Text.js.map
